(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const setupPaymentChoices = (scope = document) => {
    scope.querySelectorAll('[data-payment-choice]').forEach((choice) => {
      if (choice.dataset.paymentChoiceReady === 'true') return;

      const container = choice.closest('.product-form__buttons');
      if (!container) return;

      choice.dataset.paymentChoiceReady = 'true';

      const applyLabels = () => {
        const onlineButton = container.querySelector('.shopify-payment-button__button--unbranded');
        if (onlineButton && onlineButton.textContent.trim() !== choice.dataset.onlineLabel) {
          onlineButton.textContent = choice.dataset.onlineLabel;
          onlineButton.setAttribute('aria-label', choice.dataset.onlineLabel);
        }

        const codButton = container.querySelector('#rsi_buy_now_button');
        container.toggleAttribute('data-has-cod', Boolean(codButton));

        if (codButton) {
          const label = codButton.querySelector('svg + div');
          if (label && label.textContent.trim() !== choice.dataset.codLabel) {
            label.textContent = choice.dataset.codLabel;
          }
          codButton.setAttribute('aria-label', choice.dataset.codLabel);
        }
      };

      applyLabels();
      new MutationObserver(applyLabels).observe(container, { childList: true, subtree: true });
    });
  };

  setupPaymentChoices();
  document.addEventListener('shopify:section:load', (event) => setupPaymentChoices(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-payment-choice"] && !Shopify.designMode) return;
  try {
    const setupCartPaymentChoices = (scope = document) => {
    scope.querySelectorAll('[data-cart-payment-choice]').forEach((choice) => {
      if (choice.dataset.cartPaymentChoiceReady === 'true') return;

      const container = choice.closest('.cart__blocks, .cart-notification__links');
      if (!container) return;

      choice.dataset.cartPaymentChoiceReady = 'true';

      const applyLabels = () => {
        const onlineButton = container.querySelector('button[name="checkout"]');
        if (onlineButton) {
          if (onlineButton.textContent.trim() !== choice.dataset.onlineLabel) {
            onlineButton.textContent = choice.dataset.onlineLabel;
          }
          if (onlineButton.getAttribute('aria-label') !== choice.dataset.onlineLabel) {
            onlineButton.setAttribute('aria-label', choice.dataset.onlineLabel);
          }
        }

        const codButton = container.querySelector('#rsi_buy_now_button');
        const codWrapper = container.querySelector('#cart-wrapper');
        const codAvailable = Boolean(
          codButton &&
          !codButton.disabled &&
          codButton.getAttribute('aria-disabled') !== 'true' &&
          !codButton.hidden &&
          getComputedStyle(codButton).display !== 'none'
        );
        container.toggleAttribute('data-has-cod', codAvailable);

        if (codButton) {
          const label = codButton.querySelector('svg + div') || codButton.querySelector(':scope > div > div:last-child');
          if (label && label.textContent.trim() !== choice.dataset.codLabel) {
            label.textContent = choice.dataset.codLabel;
          }
          codButton.setAttribute('aria-label', choice.dataset.codLabel);
        }

        const onlineWrapper = onlineButton?.closest('.cart__ctas, #cart-notification-form');
        if (codWrapper && onlineButton && codWrapper.parentElement === onlineButton.parentElement) {
          if (codWrapper.nextElementSibling !== onlineButton) {
            codWrapper.parentElement.insertBefore(codWrapper, onlineButton);
          }
        } else if (
          codWrapper &&
          onlineWrapper &&
          codWrapper.parentElement === container &&
          onlineWrapper.parentElement === container &&
          codWrapper.nextElementSibling !== onlineWrapper
        ) {
          container.insertBefore(codWrapper, onlineWrapper);
        }

        const notificationForm = container.querySelector('#cart-notification-form');
        const viewCartLink = container.querySelector('#cart-notification-button');
        const directCodWrapper = codWrapper?.parentElement === container ? codWrapper : null;
        const firstPaymentNode = directCodWrapper || notificationForm;
        if (firstPaymentNode && viewCartLink && container.firstElementChild !== firstPaymentNode) {
          container.insertBefore(firstPaymentNode, container.firstElementChild);
        }
        if (
          directCodWrapper &&
          notificationForm &&
          directCodWrapper.nextElementSibling !== notificationForm
        ) {
          container.insertBefore(notificationForm, directCodWrapper.nextElementSibling);
        }
        if (viewCartLink && choice.nextElementSibling !== viewCartLink) {
          container.insertBefore(choice, viewCartLink);
        }
      };

      applyLabels();
      new MutationObserver(applyLabels).observe(container, { childList: true, subtree: true });
    });
  };

  setupCartPaymentChoices();
  document.addEventListener('shopify:section:load', (event) => setupCartPaymentChoices(event.target));
  } catch(e) { console.error(e); }
})();

})();
